<template>
    <div>
        <wallet-table
            :items="wallets"
            :options="pagination"
            @viewDetails="viewWalletDetails"
            @sort="emitWalletTableSort"/>

        <right-panel
            hideBottom
            ref="pocketDetalsRightPanel"
            :title="$t('andamandaPay.pocketDetails.header')">
            <template v-slot:content="{ context }" >
                <pocket-details-view
                    :pocket="context"/>
            </template>
        </right-panel>
    </div>
</template>

<script>
import WalletTable from '@/components/tables/WalletTable'
import RightPanel from '@/components/panels/RightPanel'
import PocketDetailsView from '@/views/PocketDetailsView'

import { mapGetters } from 'vuex'

export default {
    name: 'WalletListView',

    props: {
        wallets: {
            type: Array,
            default: () => []
        },

        pagination: {
            type: Object,
            default: () => {}
        }
    },

    components: {
        WalletTable,
        RightPanel,
        PocketDetailsView
    },

    computed: {
        ...mapGetters({
            getWalletByCustomerId: 'wallet/getWalletByCustomerId'
        })
    },

    methods: {
        async viewWalletDetails (walletItem) {
            let wallet = null
            try {
                wallet = await this.getWalletByCustomerId(walletItem.CustomerID)
            } catch (error) {
                const errorHeader = 'Wallet Not Found!'
                const errorMessage = `Not found wallet of customer ${walletItem.name}:${walletItem.CustomerID}`
                console.error(error)
                this.$app.alert(errorHeader, errorMessage)
                return
            }
            this.$refs.pocketDetalsRightPanel.open(wallet)
        },

        emitWalletTableSort (sortBy, sortType) {
            this.$emit('wallet:sort', sortBy, sortType)
        }
    }
}
</script>

<style lang="scss" scoped>

</style>
